import { render, staticRenderFns } from "./BadgeMod.vue?vue&type=template&id=48f12657"
import script from "./BadgeMod.vue?vue&type=script&lang=js"
export * from "./BadgeMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports